<template>
    <div class="main-container-l">
        <div class="loading-container" v-if="offerLoading"><img src="../../assets/img/loading.svg"></div>
        <div v-if="isMobile" class="mbmenu-verifyticket">
            <i class="iconset icon-betslip"></i>
            <router-link to="/web/verifyticket">{{ $t('VERIFYTICKET') }}</router-link>
        </div>
        <GamesMenu
        v-if="isMobile && gamesMenuShown"
        :outrightsIn="outrightsIn"
        :sports="sports"
        :pagetype="'sportoffer'"
        :sportsselected="sportsselected"
        :categoryselected="categoryselected"
        :tournamentselected="tournamentselected"
        :offerstate="sportState"
        :offertree="sportTree"
        :matchesIn="matchesIn"
        @togglegamesmenu="toggleGamesMenu"
        @selectFavourites="selectFavourites"
        @selectsport="selectSport"
        @selectcategory="selectCategory"
        @selecttournament="selectTournament"
        />

        <OfferCalendar
            v-if="isMobile && !gamesMenuShown && sportState == 'prematch'"
            @togglegamesmenu="toggleGamesMenu"
            show-back-button
            :offerLoading="offerLoading"
        />
        <div class="offer-container-l" ref="tourCont">

            <div v-if="sportState == 'live'" class="live-header-events">
                <div class="liveh-event-switch">
                    <div class="liveh-event-switch-item">{{$t('OVERVIEW')}}</div>
                </div>
                <div v-if="sportState == 'live'" class="liveh-group-games">
                </div>
            </div>
            <GamesMenu
            v-if="!isMobile"
            :outrightsIn="outrightsIn"
            :matchesIn="matchesIn"
            :sports="sports"
            :pagetype="'sportoffer'"
            :sportsselected="sportsselected"
            :categoryselected="categoryselected"
            :tournamentselected="tournamentselected"
            :offerstate="sportState"
            :offertree="sportTree"
            @selectFavourites="selectFavourites"
            @selectsport="selectSport"
            @selectcategory="selectCategory"
            @selecttournament="selectTournament"
            />
            <div class="group-offer-l" @:selectMatch="selectMatch">
                <OfferCalendar
                v-if="!isMobile && sportState == 'prematch'"
                show-back-button
                :offerLoading="offerLoading"
                ref_testcafe="groupOffer"
                />
                <SportTabs
                v-if="selectedMatches.length > 0 && smallDesktop && !isMobile"
                :selectedMatches="selectedMatches"
                :selectedMatch="selectedMatch"
                :filtersSelected="filtersSelected"
                :outrights="outrights"
                />

                <vue-scroll :settings="{wheelPropagation:true}" v-if="selectedMatch && smallDesktop && !isMobile">
                    <template v-if="selectedMatch.type == 'outright' && sportState == 'prematch'">
                        <OutrightSingle
                        v-for="outright in outrights"
                        :key="outright.outrightsOfferId"
                        :outright="outright"
                        type="sport" />
                    </template>
                    <SportSingle
                    v-else
                    :outrightsIn="outrightsIn"/>
                </vue-scroll>
                <div class="group-game-container" v-if="!isMobile">
                    <Tournaments
                    v-show="liveEventOverview && (!smallDesktop || (smallDesktop && !selectedMatch))"
                    :matchesIn="currentMatches"
                    :categoriesin="categoriesin"
                    :tournamentsin="tournamentsin"
                    :sportsselected="sportsselected"
                    :categoryselected="categoryselected"
                    :tournamentselected="tournamentselected"
                    :outrightsIn="outrightsIn"
                    @reloadoffer="reloadOffer"/>
                    <LiveEventView v-if="!liveEventOverview" />
                </div>

                <Tournaments
                v-if="isMobile"
                :matchesIn="currentMatches"
                :categoriesin="categoriesin"
                :tournamentsin="tournamentsin"
                :sportsselected="sportsselected"
                :categoryselected="categoryselected"
                :tournamentselected="tournamentselected"
                :outrightsIn="outrightsIn"
                @reloadoffer="reloadOffer"
                />
            </div>
            <div class="single-offer-l" v-if="!smallDesktop && !isMobile && selectedMatch">
                <div class="single-games-box">
                    <SportTabs
                    :selectedMatches="selectedMatches"
                    :selectedMatch="selectedMatch"
                    :filtersSelected="filtersSelected"
                    :outrights="outrights" />

                    <template v-if="selectedMatch.type == 'outright' && sportState == 'prematch'">
                        <OutrightSingle
                        v-for="outright in outrights"
                        :key="outright.outrightsOfferId"
                        :outright="outright"
                        type="sport" />
                    </template>
                    <vue-scroll :settings="{wheelPropagation:true}" v-if="(selectedMatch || selectedOutrightId !== null) && !smallDesktop">
                        <SportSingle
                        :outrightsIn="outrightsIn"/>
                    </vue-scroll>
                </div>
            </div>
        </div>
        <Betslip v-if="betslip" />
    </div>
</template>

<script>
import
{
    mapActions,
    mapGetters,
}
from 'vuex';
import moment from 'moment-timezone';
import GamesMenu from './containers/GamesMenu.vue';
import Tournaments from './containers/Tournaments.vue';
import SportTabs from './containers/SportTabs.vue';
import SportSingle from './containers/SportSingle.vue';
import Betslip from '../components/betslip/Betslip.vue';
import OfferCalendar from '../components/OfferCalendar.vue';
import OutrightSingle from './containers/OutrightsSingle.vue';
import LiveEventView from './containers/LiveEventView.vue';

export default
{
    name: 'Sport',
    components:
    {
        Betslip,
        OfferCalendar,
        GamesMenu,
        Tournaments,
        SportTabs,
        SportSingle,
        LiveEventView,
        OutrightSingle,
    },
    data()
    {
        return {
            searchBox: false,

            sportsin:
            {},
            categoriesin:
            {},
            tournamentsin:
            {},
            sportsselected: [],
            categoryselected: [],
            tournamentselected: [],

            gamesMenuShown: true,
            liveEventOverview: true,
            oddSelecteBoxLive: false,
            componentOfferLoading: true,
            outrightsIn: {
                matchIds: [],
                tournamentIds: [],
                categoryIds: [],
                sportIds: [],
            },
            selectedOutrightId: null,
            selectedOutrightIds: [],
            outrights: [],
        };
    },
    created()
    {
        const me = this;

        let sportState = 'prematch';

        if (me.$route.path.indexOf('web/live') !== -1)
        {
            sportState = 'live';
        }

        if (this.checkMaintenance())
        {
            return;
        }

        me.selectMatch(null);

        if (me.$route.params.sportId !== undefined)
        {
            if (me.$route.params.sportId === 'all'
            || me.$route.params.sportId === 'bonus')
            {
                me.sportsselected = [me.$route.params.sportId];
            }
            else
            {
                const sports = me.$route.params.sportId.split(',');

                for (const sport in sports)
                {
                    if (sports[sport] !== undefined)
                    {
                        sports[sport] = parseInt(sports[sport], 10);
                    }
                }

                me.sportsselected = Object.values(sports);
            }
        }

        if (me.$route.params.categoryId !== undefined)
        {
            if (me.$route.params.categoryId === 'bonus1'
            || me.$route.params.categoryId === 'bonus2')
            {
                me.categoryselected = [me.$route.params.categoryId];
            }
            else
            {
                const categories = me.$route.params.categoryId.split(',');

                for (const category in categories)
                {
                    if (categories[category] !== undefined)
                    {
                        categories[category] = parseInt(categories[category], 10);
                    }
                }

                me.categoryselected = Object.values(categories);
            }
        }

        if (me.$route.params.tournamentId !== undefined)
        {
            const tournaments = me.$route.params.tournamentId.split(',');

            for (const tournament in tournaments)
            {
                if (tournaments[tournament] !== undefined)
                {
                    tournaments[tournament] = parseInt(tournaments[tournament], 10);
                }
            }

            me.tournamentselected = Object.values(tournaments);
        }

        me.initSportOffer(
            {
                sportState,
                setMatchesByTournamentsData: true,
            },
        );
        if (me.globals
            && me.globals.publicConfig
            && me.globals.publicConfig.verticalsAvailable
            && me.globals.publicConfig.verticalsAvailable.outrights
            && sportState === 'prematch')
        {
            me.fetchOutrightOffer();
        }

        if (this.betslipType !== 'sport')
        {
            me.toggleBetslipDef('simple');
        }

        me.clearOtherItems([
            'sport',
            'outrights',
        ]);

        me.loadBetslipStorageItems({
            type: 'sport',
            skipFetch: this.betslipType === 'sport',
        });
    },
    beforeDestroy()
    {
        const me = this;

        me.destroySportOffer({ ignore: ['lotto', 'vhorse'] });
        me.destroyOutrightOffer();
    },
    methods:
    {
        ...mapActions(
            {
                selectMatch: 'selectMatch',
                getOfferByDateInit: 'getOfferByDate',
                selectDateInit: 'selectDate',
                initSportOfferInit: 'initSportOffer',
                destroySportOffer: 'destroySportOffer',
                setTree: 'setTree',
                changeSportOfferLanguage: 'changeSportOfferLanguage',
                selectSpecialDate: 'selectSpecialDate',
                selectMatches: 'selectMatches',
                selectEvent: 'selectEvent',
                fetchOutrights: 'fetchOutrights',
                setSelectedOutrightId: 'setSelectedOutrightId',
                initOutrightsOffer: 'initOutrightsOffer',
                destroyOutrightOffer: 'destroyOutrightOffer',
                setConnectedOutrights: 'setConnectedOutrights',
                toggleBetslipDef: 'toggleBetslipDef',
                clearOtherItems: 'clearOtherItems',
                loadBetslipStorageItems: 'loadBetslipStorageItems',
            },
        ),
        async reloadOffer()
        {
            const me = this;

            me.changeSportOfferLanguage({ ignore: ['lotto', 'vhorse'] });

            const params = {
                resubscribeMatches: true,
                sportState: 'prematch',
                setMatchesByTournamentsData: true,
            };

            if (me.$route.path.indexOf('web/live') !== -1)
            {
                params.sportState = 'live';
            }

            await me.initSportOffer(params);
        },
        toggleGamesMenu()
        {
            const me = this;
            me.gamesMenuShown = !me.gamesMenuShown;
        },
        showSearchBox()
        {
            const me = this;
            me.searchBox = !me.searchBox;

            me.$nextTick(() =>
            {
                if (me.$refs.searchBoxInput)
                {
                    me.$refs.searchBoxInput.focus();
                }
            });
        },
        selectFavourites()
        {
            if (this.smallDesktop)
            {
                this.selectMatch(null);
            }
            this.$router.push({
                params: {
                    sportId: 'all',
                    mode: 'favourites',
                },
            });
        },
        selectSport(val)
        {
            const me = this;
            if (me.smallDesktop)
            {
                me.selectMatch(null);
            }

            me.$router.push({
                params: {
                    sportId: (val.length) ? val.join(',') : undefined,
                    categoryId: undefined,
                    tournamentId: undefined,
                    mode: undefined,
                },
            });
        },
        selectCategory(val)
        {
            const me = this;
            if (me.smallDesktop)
            {
                me.selectMatch(null);
            }

            me.$router.push({
                params: {
                    sportId: val.sportId,
                    categoryId: val.categoryId,
                    tournamentId: undefined,
                    mode: undefined,
                },
            });
        },
        selectTournament(val)
        {
            const me = this;
            if (me.smallDesktop)
            {
                me.selectMatch(null);
            }

            me.$router.push({
                params: {
                    sportId: val.sportId,
                    categoryId: val.categoryId,
                    tournamentId: val.tournamentId,
                    mode: undefined,
                },
            });
        },
        getConnectedOutrights()
        {
            const me = this;
            const filterOutrights = [];
            me.outrightsIn = {
                matchIds: [],
                tournamentIds: [],
                categoryIds: [],
                sportIds: [],
            };

            // eslint-disable-next-line guard-for-in
            for (const outrightId in me.getOutrights)
            {
                const outright = me.getOutrights[outrightId];
                for (const treeItem of outright.tree)
                {
                    if (treeItem.connectionId != null)
                    {
                        if (!filterOutrights.includes(outright))
                        {
                            filterOutrights.push(outright);
                        }

                        if (treeItem.connectionType === 'tournament'
                            && !me.outrightsIn.tournamentIds.includes(treeItem.connectionId))
                        {
                            me.outrightsIn.tournamentIds.push(treeItem.connectionId);
                        }
                        else if (treeItem.connectionType === 'category'
                            && !me.outrightsIn.categoryIds.includes(treeItem.connectionId))
                        {
                            me.outrightsIn.categoryIds.push(treeItem.connectionId);
                        }
                        else if (treeItem.connectionType === 'sport'
                            && !me.outrightsIn.sportIds.includes(treeItem.connectionId))
                        {
                            me.outrightsIn.sportIds.push(treeItem.connectionId);
                        }
                        else if (treeItem.connectionType === 'match'
                            && !me.outrightsIn.matchIds.includes(treeItem.connectionId))
                        {
                            me.outrightsIn.matchIds.push(treeItem.connectionId);
                        }
                    }
                }
            }

            const groupedOutrights = {};
            let connectedOutrights = {};

            for (const outright of filterOutrights)
            {
                const treeItemName = outright.tree[0].name;

                if (groupedOutrights[treeItemName] == null)
                {
                    groupedOutrights[treeItemName] = {
                        type: 'outrights',
                        itemId: outright.tree[0].treeItemId,
                        tournamentId: `outright_${outright.tree[0].treeItemId}`,
                        name: treeItemName,
                        marketsSelected: [],
                        outrights: [],
                    };
                }
                groupedOutrights[treeItemName].outrights.push(outright);
            }
            me.outrights = filterOutrights;

            connectedOutrights = Object.values(groupedOutrights);
            me.setConnectedOutrights(connectedOutrights);
        },
        async fetchOutrightOffer()
        {
            const me = this;

            await me.initOutrightsOffer('sport');

            me.getConnectedOutrights();
        },
        async getOfferByDate(param = {})
        {
            const me = this;

            if (me.startDate === false)
            {
                return;
            }

            me.sportsin = {};
            me.categoriesin = {};
            me.tournamentsin = {};

            me.getOfferByDateInit(param);

            me.offerHandling.setOfferReloadFunctions({
                name: 'getSportOffer',
                func: async () =>
                {
                    me.getOfferByDateInit({
                        resetSelectedMatches: false,
                        fetchSelectedMatches: true,
                        emptyMatches: true,
                    });

                    if (me.globals
                    && me.globals.publicConfig
                    && me.globals.publicConfig.verticalsAvailable
                    && me.globals.publicConfig.verticalsAvailable.outrights
                    && me.sportState === 'prematch')
                    {
                        me.fetchOutrightOffer();
                    }
                },
            });

            if (me.globals
            && me.globals.publicConfig
            && me.globals.publicConfig.verticalsAvailable
            && me.globals.publicConfig.verticalsAvailable.outrights
            && me.sportState === 'prematch')
            {
                me.fetchOutrightOffer();
            }
        },
        async getDateTimeParams(setDate = false)
        {
            const me = this;

            let params = {
                startDate: moment.utc(),
                endDate: moment().add(1, 'y').set({
                    hours: 10,
                    minutes: 0,
                    seconds: 0,
                }).utc(),
                setDate,
            };

            if (me.sportState === 'live')
            {
                params = {
                    startDate: moment.utc(),
                    endDate: moment.utc(),
                };
            }
            else if (me.$route.params && me.$route.params.startDate)
            {
                params = await me.selectSpecialDate({
                    date: me.$route.params.startDate,
                    setSpecialDate: true,
                });
            }

            if (params.setDate)
            {
                me.$router.push({
                    params:
                    {
                        startDate: moment.utc(params.startDate).local().format('YYYY-MM-DD'),
                    },
                });
            }

            return params;
        },
        async initSportOffer(param)
        {
            const me = this;

            if (param.sportState === 'live')
            {
                await me.initSportOfferInit({
                    sportState: 'live',
                    startDate: moment.utc(),
                    endDate: moment.utc().add(1, 'y'),
                    setDate: true,
                    setMatchesByTournamentsData: true,
                });
            }
            else
            {
                await me.initSportOfferInit({
                    sportState: 'prematch',
                    setDate: false,
                    skipDateSetup: true,
                    setMatchesByTournamentsData: true,
                });

                await me.getDateTimeParams(true);
            }
        },
        checkMaintenance()
        {
            if (this.maintenance[this.getSportState])
            {
                this.$router.push({ name: 'maintenance' });
                return true;
            }

            return false;
        },
    },
    computed:
    {
        ...mapGetters([
            'globals',
            'isMobile',
            'sportState',
            'selectedMatch',
            'sportTree',
            'selectedMatches',
            'smallDesktop',
            'matchesIn',
            'startDate',
            'endDate',
            'offerLoading',
            'offerHandling',
            'subscribedMatches',
            'getOutrights',
            'maintenance',
            'betslip',
            'betslipType',
        ]),
        ...mapGetters('favourites', [
            'favouritesOnCurrentOffer',
            'favouriteMatchesIn',
        ]),
        onFavourites()
        {
            return this.$route.params.mode === 'favourites';
        },
        currentMatches()
        {
            if (this.onFavourites)
            {
                return this.favouriteMatchesIn;
            }
            return this.matchesIn;
        },
        sports()
        {
            const me = this;

            const sports = [];
            for (const key in me.sportsin)
            {
                if (me.sportsin[key] !== undefined)
                {
                    const categories = [];
                    const { sportId } = me.sportsin[key];

                    for (const keyCat in me.categoriesin[sportId])
                    {
                        if (me.categoriesin[sportId][keyCat] !== undefined)
                        {
                            const cat = me.categoriesin[sportId][keyCat];

                            const { categoryId } = cat;

                            const tournaments = [];
                            for (const keyTour in me.tournamentsin[categoryId])
                            {
                                if (me.tournamentsin[categoryId][keyTour] !== undefined)
                                {
                                    const tour = me.tournamentsin[categoryId][keyTour];
                                    tournaments.push(tour);
                                }
                            }

                            tournaments.stableSort((a, b) =>
                            {
                                if (a.tournamentOrder < b.tournamentOrder)
                                {
                                    return -1;
                                }

                                if (a.tournamentOrder > b.tournamentOrder)
                                {
                                    return 1;
                                }

                                return 0;
                            });

                            cat.tournaments = tournaments;

                            categories.push(cat);
                        }
                    }

                    if (categories.length > 1)
                    {
                        categories.sort((a, b) =>
                        {
                            if (a.categoryOrder < b.categoryOrder)
                            {
                                return -1;
                            }

                            if (a.categoryOrder > b.categoryOrder)
                            {
                                return 1;
                            }

                            return 0;
                        });
                    }

                    me.sportsin[key].categories = categories;

                    sports.push(me.sportsin[key]);
                }
            }

            sports.stableSort((a, b) =>
            {
                if (a.sportOrder < b.sportOrder)
                {
                    return -1;
                }

                if (a.sportOrder > b.sportOrder)
                {
                    return 1;
                }

                return 0;
            });

            if (me.sportsselected[0] === undefined && sports[0] !== undefined)
            {
                me.selectSport([sports[0].sportId]);
            }

            if (sports.length
            && me.sportsselected[0] != null
            && me.sportsselected[0] !== 'all')
            {
                let sportExists = false;
                let sportOut = null;

                for (const sport of sports)
                {
                    if (sport.sportId === me.sportsselected[0])
                    {
                        sportOut = sport;
                        sportExists = true;
                        break;
                    }
                }

                if (!sportExists)
                {
                    me.selectSport([sports[0].sportId]);
                }
                else if (sportOut.categories.length
                && me.categoryselected[0] != null)
                {
                    let categoryExists = false;
                    let categoryOut = null;

                    for (const category of sportOut.categories)
                    {
                        if (category.categoryId === me.categoryselected[0])
                        {
                            categoryOut = category;
                            categoryExists = true;
                            break;
                        }
                    }

                    if (!categoryExists)
                    {
                        me.selectSport([sportOut.sportId]);
                    }
                    else if (categoryOut.tournaments.length && me.tournamentselected[0] != null)
                    {
                        let tournamentExists = false;

                        for (const tournament of categoryOut.tournaments)
                        {
                            if (tournament.tournamentId === me.tournamentselected[0])
                            {
                                tournamentExists = true;
                                break;
                            }
                        }

                        if (!tournamentExists)
                        {
                            me.selectCategory({
                                sportId: sportOut.sportId,
                                categoryId: categoryOut.categoryId,
                            });
                        }
                    }
                }
            }

            return sports;
        },
        matches()
        {
            const me = this;

            const tournamentId = me.tournamentselected[0];

            const matches = [];
            for (const key in me.matchesIn)
            {
                if (me.matchesIn[key] !== undefined)
                {
                    const match = me.matchesIn[key];
                    if (match.tournamentId === tournamentId)
                    {
                        matches.push(match);
                    }
                }
            }

            matches.sort((a, b) =>
            {
                const as = moment(a.matchDate);
                const bs = moment(b.matchDate);

                if (as < bs)
                {
                    return -1;
                }

                if (as > bs)
                {
                    return 1;
                }

                if (a.teamNameOne < b.teamNameOne)
                {
                    return -1;
                }

                if (a.teamNameOne > b.teamNameOne)
                {
                    return 1;
                }

                return 0;
            });

            return matches;
        },
        filtersSelected()
        {
            const me = this;

            let filtersConcat = '';

            if (this.onFavourites)
            {
                return this.$t('FAVOURITES');
            }

            if (me.sportsselected[0] === 'all')
            {
                return me.$i18n.t('ALLSPORTSSELECTED');
            }

            if (me.sportsselected[0])
            {
                if (me.sportsselected[0] === 'bonus')
                {
                    filtersConcat += me.sportsin[me.sportsselected[0]].sportName;
                }
                else
                {
                    filtersConcat += me.sportTree.sports[me.sportsselected[0]].sportName;
                }
            }

            if (me.categoryselected[0])
            {
                if (me.categoryselected[0] === 'bonus1'
                || me.categoryselected[0] === 'bonus2')
                {
                    filtersConcat += ` - ${me.categoriesin[me.sportsselected[0]][me.categoryselected[0]].categoryName}`;
                }
                else
                {
                    filtersConcat += ` - ${me.sportTree.categories[me.categoryselected[0]].categoryName}`;
                }
            }

            if (me.tournamentselected[0])
            {
                filtersConcat += ` - ${me.sportTree.tournaments[me.tournamentselected[0]].tournamentName}`;
            }

            return filtersConcat;
        },
        getSportState()
        {
            if (this.$route.path.indexOf('web/live') !== -1)
            {
                return 'live';
            }

            return 'prematch';
        },
    },
    watch:
    {
        getOutrights()
        {
            const me = this;
            me.getConnectedOutrights();
        },
        selectedMatch(val)
        {
            if (val == null)
            {
                return;
            }

            if (val.type === 'outright')
            {
                this.setSelectedOutrightId(val.id);
            }
        },
        favouritesOnCurrentOffer(favs)
        {
            if (!favs.length && this.onFavourites)
            {
                this.selectSport(['all']);
            }
        },
        sportState(val, oldVal)
        {
            const me = this;

            let shouldReset = false;

            if (val !== undefined
            && oldVal !== undefined)
            {
                if (val === 'live' && me.$route.params.startDate != null)
                {
                    shouldReset = true;
                }

                else if (val === 'prematch'
                && me.$route.params.startDate == null
                && (me.$route.params.sportId != null
                || me.$route.params.categoryId != null
                || me.$route.params.tournamentId != null))
                {
                    shouldReset = true;
                }
            }

            if (shouldReset)
            {
                me.$router.push({
                    startDate: null,
                    sportId: null,
                    categoryId: null,
                    tournamentId: null,
                    mode: null,
                });

                window.scrollTo(0, 0);
            }
        },
        '$route.params.sportId'(val)
        {
            const me = this;

            if (val === 'all'
            || val === 'bonus')
            {
                me.sportsselected = [val];
            }
            else
            {
                const sports = (val !== undefined) ? val.toString().split(',') : [];

                for (const sport in sports)
                {
                    if (sports[sport] !== undefined)
                    {
                        sports[sport] = parseInt(sports[sport], 10);
                    }
                }

                me.sportsselected = Object.values(sports);
            }
        },
        '$route.params.categoryId'(val)
        {
            const me = this;

            if (val === 'bonus1'
            || val === 'bonus2')
            {
                me.categoryselected = [val];
            }
            else
            {
                const categories = (val !== undefined) ? val.toString().split(',') : [];

                for (const category in categories)
                {
                    if (categories[category] !== undefined)
                    {
                        categories[category] = parseInt(categories[category], 10);
                    }
                }

                me.categoryselected = Object.values(categories);
            }
        },
        '$route.params.tournamentId'(val)
        {
            const me = this;

            const tournaments = (val !== undefined) ? val.toString().split(',') : [];

            for (const tournament in tournaments)
            {
                if (tournaments[tournament] !== undefined)
                {
                    tournaments[tournament] = parseInt(tournaments[tournament], 10);
                }
            }

            me.tournamentselected = Object.values(tournaments);
        },
        '$route.params.startDate'(val)
        {
            const me = this;

            if (val !== undefined)
            {
                me.selectSpecialDate({
                    date: val,
                    setSpecialDate: true,
                });
            }
        },
        '$route.path'(val)
        {
            const me = this;
            if (val == null || val === undefined)
            {
                return;
            }
            if (val.indexOf('web/live') !== -1)
            {
                if (me.sportState === 'live')
                {
                    return;
                }

                me.initSportOffer(
                    {
                        sportState: 'live',
                        startDate: moment.utc().subtract(1, 'd'),
                        endDate: moment.utc(),
                        setMatchesByTournamentsData: true,
                    },
                );
            }
            else
            {
                if (me.sportState === 'prematch')
                {
                    return;
                }

                me.initSportOffer(
                    {
                        sportState: 'prematch',
                        startDate: moment.utc(),
                        endDate: moment().add(1, 'day').set(
                            {
                                hours: 10,
                                minutes: 0,
                                seconds: 0,
                            },
                        ).utc(),
                        setMatchesByTournamentsData: true,
                    },
                );
            }
        },
        sports(val)
        {
            const me = this;

            if (me.sportsselected[0] === 'all')
            {
                return;
            }

            if (me.sportsselected[0] !== undefined)
            {
                for (const sport in val)
                {
                    if (parseInt(sport, 10) === parseInt(me.sportsselected[0], 10))
                    {
                        return;
                    }
                }
            }
        },
        smallDesktop(val)
        {
            const me = this;

            if (!me.isMobile)
            {
                if (val)
                {
                    me.selectMatch(null);
                }
                else if (me.selectedMatch == null
                && me.selectedMatches[0]
                && me.selectedMatches[0].type === 'sport')
                {
                    me.selectMatch(me.selectedMatches[0]);
                }
            }
        },
        matchesIn:
        {
            handler()
            {
                const me = this;

                me.sportsin = {};
                me.categoriesin = {};
                me.tournamentsin = {};

                let startDate;
                let endDate;

                let timezoneTemp = moment.tz.guess();

                if (me.globals
                && me.globals.publicConfig
                && me.globals.publicConfig.localeSetup
                && me.globals.publicConfig.localeSetup.web
                && me.globals.publicConfig.localeSetup.web.timezone)
                {
                    timezoneTemp = me.globals.publicConfig.localeSetup.web.timezone;
                }

                if (me.sportState === 'live')
                {
                    endDate = moment.utc();
                    startDate = moment.utc().subtract(1, 'year');
                }
                else
                {
                    const startDateOut = moment
                        .utc(me.startDate)
                        .tz(timezoneTemp).format('YYYY-MM-DD');

                    endDate = moment
                        .utc(me.endDate)
                        .tz(timezoneTemp).valueOf();

                    if (['+3h', '+6h', '+12h'].indexOf(me.specialDate) !== -1)
                    {
                        startDate = moment.utc();
                    }
                    if (moment().format('YYYY-MM-DD') === startDateOut)
                    {
                        startDate = moment.utc();
                    }
                    else
                    {
                        startDate = moment(me.startDate).utc();
                    }

                    if (me.specialDate === '+3h')
                    {
                        endDate = moment.utc(startDate).add(3, 'h').format();
                    }
                    else if (me.specialDate === '+6h')
                    {
                        endDate = moment.utc(startDate).add(6, 'h').format();
                    }
                    else if (me.specialDate === '+12h')
                    {
                        endDate = moment.utc(startDate).add(12, 'h').format();
                    }
                    else if (me.specialDate === 'all')
                    {
                        endDate = moment
                            .utc(me.endDate)
                            .tz(timezoneTemp).format('YYYY-MM-DD');
                    }
                }

                startDate = startDate.valueOf();
                endDate = endDate.valueOf();

                for (const matchId in me.matchesIn)
                {
                    if (me.matchesIn[matchId] !== undefined)
                    {
                        const match = me.matchesIn[matchId];

                        const matchUtcDate = moment.utc(match.matchDate).valueOf();

                        if (matchUtcDate < startDate
                        || matchUtcDate > endDate)
                        {
                            continue;
                        }

                        if (typeof me.sportsin[match.sportId] === 'undefined')
                        {
                            let sportName = me.$t('UNDEFINEDSPORTNAME');
                            let sportOrder = 10000;

                            if (me.sportTree.sports[match.sportId] !== undefined)
                            {
                                sportName = me.sportTree.sports[match.sportId].sportName;
                                sportOrder = me.sportTree.sports[match.sportId].sportOrder;
                            }

                            me.sportsin[match.sportId] = {
                                sportName,
                                sportOrder,
                                sportId: match.sportId,
                                matchesNum: 0,
                                matches: [],
                            };
                        }

                        me.sportsin[match.sportId].matchesNum += 1;
                        me.sportsin[match.sportId].matches.push(match);

                        if (match.state === 'prematch'
                        && match.matchTags !== undefined
                        && match.matchTags !== null
                        && match.matchTags.length)
                        {
                            const matchTags = match.matchTags.split(',');

                            for (const matchTag of matchTags)
                            {
                                if (matchTag !== 'bonus1'
                                && matchTag !== 'bonus2')
                                {
                                    continue;
                                }

                                if (me.sportsin.bonus === undefined)
                                {
                                    const sportName = me.$t('SPORTFILTER_BONUS');
                                    const sportOrder = -10;

                                    me.sportsin.bonus = {
                                        sportName,
                                        sportOrder,
                                        sportId: 'bonus',
                                        matchesNum: 0,
                                        matches: [],
                                    };
                                }

                                me.sportsin.bonus.matchesNum += 1;
                                me.sportsin.bonus.matches.push(match);

                                if (me.categoriesin.bonus === undefined)
                                {
                                    me.categoriesin.bonus = {};
                                }

                                if (me.categoriesin.bonus[matchTag] === undefined)
                                {
                                    let categoryName = me.$t('UNDEFINEDCATEGORYNAME');
                                    let categoryOrder = -100;

                                    if (matchTag === 'bonus2')
                                    {
                                        categoryOrder = -10;

                                        categoryName = me.$t('BONUSTWOTOURNAMENTNAME');
                                    }
                                    else
                                    {
                                        categoryName = me.$t('BONUSONETOURNAMENTNAME');
                                    }

                                    me.categoriesin.bonus[matchTag] = {
                                        categoryName,
                                        categoryOrder,
                                        categoryId: matchTag,
                                        matchesNum: 0,
                                        hasTournamentFilter: false,
                                    };
                                }

                                me.categoriesin.bonus[matchTag].matchesNum += 1;
                            }
                        }

                        if (typeof me.categoriesin[match.sportId] === 'undefined')
                        {
                            me.categoriesin[match.sportId] = {};
                        }

                        if (typeof me.categoriesin[match.sportId][match.categoryId] === 'undefined')
                        {
                            let categoryName = me.$t('UNDEFINEDCATEGORYNAME');
                            let categoryOrder = 10000;

                            if (me.sportTree.categories[match.categoryId] !== undefined)
                            {
                                categoryName = me.sportTree.categories[match.categoryId].categoryName;
                                categoryOrder = me.sportTree.categories[match.categoryId].categoryOrder;
                            }

                            me.categoriesin[match.sportId][match.categoryId] = {
                                categoryName,
                                categoryOrder,
                                categoryId: match.categoryId,
                                matchesNum: 0,
                                hasTournamentFilter: true,
                            };
                        }

                        me.categoriesin[match.sportId][match.categoryId].matchesNum += 1;

                        if (typeof me.tournamentsin[match.categoryId] === 'undefined')
                        {
                            me.tournamentsin[match.categoryId] = {};
                        }

                        if (typeof me.tournamentsin[match.categoryId][match.tournamentId] === 'undefined')
                        {
                            let tournamentName = me.$t('UNDEFINEDTOURNAMENTNAME');
                            let tournamentOrder = 10000;

                            if (me.sportTree.tournaments[match.tournamentId] !== undefined)
                            {
                                tournamentName = me.sportTree.tournaments[match.tournamentId].tournamentName;
                                tournamentOrder = me.sportTree.tournaments[match.tournamentId].tournamentOrder;
                            }

                            me.tournamentsin[match.categoryId][match.tournamentId] = {
                                tournamentName,
                                tournamentId: match.tournamentId,
                                tournamentOrder,
                                matchesNum: 0,
                            };
                        }

                        me.tournamentsin[match.categoryId][match.tournamentId].matchesNum += 1;
                    }
                }

                for (const sportTemp in me.sportsin)
                {
                    if (me.sportsin[sportTemp] !== undefined)
                    {
                        const tournamentsOutTemp = {};

                        for (const match of me.sportsin[sportTemp].matches)
                        {
                            if (!tournamentsOutTemp[match.tournamentId])
                            {
                                let tournamentSportOrder = 9999999;
                                let tournamentOrder = 10000;
                                let tournamentName = this.$t('UNDEFINEDTOURNAMENTNAME');
                                let sportOrder = 10000;
                                let categoryOrder = 10000;

                                if (me.sportTree.tournaments[match.tournamentId])
                                {
                                    tournamentOrder = me.sportTree.tournaments[match.tournamentId].tournamentOrder;
                                    // eslint-disable-next-line vue/max-len
                                    tournamentSportOrder = me.sportTree.tournaments[match.tournamentId].tournamentSportOrder;
                                    tournamentName = me.sportTree.tournaments[match.tournamentId].tournamentName;
                                }
                                if (me.sportTree.sports[match.sportId])
                                {
                                    sportOrder = me.sportTree.sports[match.sportId].sportOrder;
                                }
                                if (me.sportTree.categories[match.categoryId])
                                {
                                    categoryOrder = me.sportTree.categories[match.categoryId].categoryOrder;
                                }

                                tournamentsOutTemp[match.tournamentId] = {
                                    tournamentOrder,
                                    tournamentSportOrder,
                                    tournamentName: tournamentName.trim(),
                                    sportOrder,
                                    categoryOrder,
                                    matches: [],
                                };
                            }

                            tournamentsOutTemp[match.tournamentId].matches.push(match);
                        }

                        const tournamentsOut = [];

                        for (const tourId in tournamentsOutTemp)
                        {
                            if (tournamentsOutTemp[tourId] !== undefined)
                            {
                                tournamentsOut.push(tournamentsOutTemp[tourId]);
                            }
                        }

                        tournamentsOut.stableSort((a, b) =>
                        {
                            if (a.tournamentOrder < b.tournamentOrder)
                            {
                                return -1;
                            }

                            if (a.tournamentOrder > b.tournamentOrder)
                            {
                                return 1;
                            }

                            return 0;
                        });

                        tournamentsOut.stableSort((a, b) =>
                        {
                            if (a.categoryOrder < b.categoryOrder)
                            {
                                return -1;
                            }

                            if (a.categoryOrder > b.categoryOrder)
                            {
                                return 1;
                            }

                            return 0;
                        });

                        tournamentsOut.stableSort((a, b) =>
                        {
                            if (a.tournamentSportOrder != null && b.tournamentSportOrder == null)
                            {
                                return -1;
                            }

                            if (a.tournamentSportOrder == null && b.tournamentSportOrder != null)
                            {
                                return 1;
                            }

                            if (a.tournamentSportOrder == null && b.tournamentSportOrder == null)
                            {
                                return 0;
                            }

                            if (a.tournamentSportOrder < b.tournamentSportOrder)
                            {
                                return -1;
                            }

                            if (a.tournamentSportOrder > b.tournamentSportOrder)
                            {
                                return 1;
                            }

                            if (a.tournamentName < b.tournamentName)
                            {
                                return -1;
                            }

                            if (a.tournamentName > b.tournamentName)
                            {
                                return 1;
                            }

                            return 0;
                        });

                        const matchesOut = [];

                        for (const tour of tournamentsOut)
                        {
                            if (tour.matches.length > 1)
                            {
                                tour.matches.stableSort((a, b) =>
                                {
                                    const matchOne = me.matchesIn[a.matchId];
                                    const matchTwo = me.matchesIn[b.matchId];

                                    if (matchOne !== undefined
                                    && matchTwo === undefined)
                                    {
                                        return 1;
                                    }

                                    if (matchOne === undefined
                                    && matchTwo !== undefined)
                                    {
                                        return -1;
                                    }

                                    if (matchOne === undefined
                                    && matchTwo === undefined)
                                    {
                                        return 0;
                                    }

                                    const aStart = moment(matchOne.matchDate);
                                    const bStart = moment(matchTwo.matchDate);

                                    if (aStart < bStart)
                                    {
                                        return -1;
                                    }

                                    if (aStart > bStart)
                                    {
                                        return 1;
                                    }

                                    if (matchOne.teamNameOne < matchTwo.teamNameOne)
                                    {
                                        return -1;
                                    }

                                    if (matchOne.teamNameOne > matchTwo.teamNameOne)
                                    {
                                        return 1;
                                    }

                                    return 0;
                                });
                            }

                            matchesOut.push(...tour.matches);
                        }

                        me.sportsin[sportTemp].matches = matchesOut;
                    }
                }

                me.sportsin = {
                    ...me.sportsin,
                };
                me.categoriesin = {
                    ...me.categoriesin,
                };
                me.tournamentsin = {
                    ...me.tournamentsin,
                };
            },
            deep: true,
        },
        startDate(val)
        {
            const me = this;
            if (val === false)
            {
                return;
            }

            me.getOfferByDate({
                deleteSubscriptions: true,
                emptyMatches: true,
            });
        },
        async 'globals.langCode'()
        {
            const me = this;

            me.reloadOffer();
        },
        maintenance()
        {
            this.checkMaintenance();
        },
    },
};
</script>
